//
// parseUserAgent
//
// Order matters in every table: a vendor token (SamsungBrowser, OPR, EdgA...) sits next to the engine
// tokens it was built on (Chrome, Safari), so specific rules come first and engine names last.
//
const VERSION = '([\\w.]+)';

const browserRules = [
  [`CriOS/${VERSION}`, 'Mobile Chrome'],
  [`Edg(?:e|iOS|A)?/${VERSION}`, 'Edge'],
  [`OPiOS/${VERSION}`, 'Opera Mini'],
  [`Opera Mini/${VERSION}`, 'Opera Mini'],
  [` OPT/${VERSION}`, 'Opera Touch'],
  [`OPR/${VERSION}`, 'Opera'],
  [`Opera.+Version/${VERSION}`, 'Opera'],
  [`Vivaldi/${VERSION}`, 'Vivaldi'],
  [`SamsungBrowser/${VERSION}`, 'Samsung Internet'],
  [`DuckDuckGo/${VERSION}`, 'DuckDuckGo'],
  [`Focus/${VERSION}`, 'Firefox Focus'],
  [`FxiOS/${VERSION}`, 'Mobile Firefox'],
  [`YaBrowser/${VERSION}`, 'Yandex'],
  [`MiuiBrowser/${VERSION}`, 'MIUI Browser'],
  [`HuaweiBrowser/${VERSION}`, 'Huawei Browser'],
  [`UCBrowser/${VERSION}`, 'UCBrowser'],
  [`Silk/${VERSION}`, 'Silk'],
  [`FBAV/${VERSION}`, 'Facebook'],
  [`Instagram ${VERSION}`, 'Instagram'],
  [`GSA/${VERSION}`, 'GSA'],
  ['\\[LinkedInApp\\]', 'LinkedIn'],
  [`IEMobile/${VERSION}`, 'IEMobile'],
  [`Trident/.+rv:${VERSION}`, 'IE'],
  [`MSIE ${VERSION}`, 'IE'],
  [`HeadlessChrome/${VERSION}`, 'Chrome Headless'],
  [`; wv\\).+Chrome/${VERSION}`, 'Chrome WebView'],
  [`Chromium/${VERSION}`, 'Chromium'],
  [`Chrome/${VERSION} Mobile`, 'Mobile Chrome'],
  [`Chrome/${VERSION}`, 'Chrome'],
  [`(?:Mobile|Tablet);.*Firefox/${VERSION}`, 'Mobile Firefox'],
  [`Firefox/${VERSION}`, 'Firefox'],
  [`Android.+Version/${VERSION}.+Safari`, 'Android Browser'],
  [`Version/${VERSION}.*Mobile.*Safari`, 'Mobile Safari'],
  ['iPhone.*Mobile.*Safari', 'Mobile Safari'],
  [`Version/${VERSION}.*Safari`, 'Safari'],
  [`AppleWebKit/${VERSION}`, 'WebKit'],
].map(([pattern, name]) => [new RegExp(pattern), name]);

const osRules = [
  [/Windows Phone/, 'Windows Phone'],
  [/Windows NT|Windows /, 'Windows'],
  [/iPhone|iPad|iPod/, 'iOS'],
  [/Macintosh|Mac OS X/, 'macOS'],
  [/CrOS/, 'Chrome OS'],
  [/HarmonyOS/, 'HarmonyOS'],
  [/Android/, 'Android'],
  [/Tizen/, 'Tizen'],
  [/Ubuntu/, 'Ubuntu'],
  [/Fedora/, 'Fedora'],
  [/Linux|X11/, 'Linux'],
];

// An Android UA without the "Mobile" token is a tablet (Chrome, Samsung Internet and WebViews all follow this)
const deviceTypeRules = [
  [/SMART-TV|Android TV|\bTV Safari\b/, 'smarttv'],
  [/iPad/, 'tablet'],
  [/iPhone|iPod/, 'mobile'],
  [/Opera Mini|Windows Phone|IEMobile|\bMobi/, 'mobile'],
  [/Android|\bTablet\b/, 'tablet'],
];

const firstMatch = (rules, userAgent) => {
  let found;
  rules.some(([regex, name]) => {
    const match = regex.exec(userAgent);
    if (match) found = { name, version: match[1] };
    return Boolean(match);
  });
  return found;
};

const parseUserAgent = (userAgent) => {
  const result = {};
  if (!userAgent) return result;

  const browser = firstMatch(browserRules, userAgent);
  if (browser) {
    result.browserName = browser.name;
    if (browser.version) result.browserVersion = browser.version;
  }

  const os = firstMatch(osRules, userAgent);
  if (os) result.osName = os.name;

  const deviceType = firstMatch(deviceTypeRules, userAgent);
  if (deviceType) result.deviceType = deviceType.name;

  return result;
};
export default parseUserAgent;
